import { takeEvery, put } from "redux-saga/effects";

import axios from "axios";

import { cartApi } from "../../../utility/api/apiList";

import cartType from "./cartType";
import {
  successFetchedCartDetail,
  failedFetchedCarttDetail,
  handleSetIsPersonal,
  handleSetIsCompany,
} from "./cartActions";

export function* startFetchingCart(action) {

    try {
    const response = yield axios.get(`${cartApi}${action.search}`)
   const handlesuccess= yield put(successFetchedCartDetail(response.data))
   if(response.data.data[0].salespackage.id!==undefined){
       yield put(handleSetIsPersonal)
   }else{
    yield put(handleSetIsCompany)

   }

    }catch(error){

const handleError = yield put(failedFetchedCarttDetail(error.response))
    }
    
}

export function* fetchCart() {
    yield takeEvery(cartType.START_FETCHING_CART_DETAILS,startFetchingCart)
}



